import React, { useState, useRef } from "react"
import { Space, Button } from "@atos6/ui"
import { Paragraph, Padding } from "../../ui"
import { RadioRgCnh } from "@atos6/components"
import { UploadButtons } from "./DocumentUploadCell.styles"
import { ZoopUploader } from "./ZoopUploader"

type Props = {
  onChange: () => void
}

export function Juridica({ onChange }: Props) {
  const [rgCnh, setRgCnh] = useState(RadioRgCnh.rg)
  const [rgFrenteFile, setRgFrenteFile] = useState<Function>()
  const [rgVersoFile, setRgVersoFile] = useState<Function>()
  const [cnhFile, setCnhFile] = useState<Function>()
  const [isLoading, setIsLoading] = useState(false)

  const uploadStatus = useRef({
    rgFrente: false,
    rgVerso: false,
    cnh: false,
  })

  const isRg = rgCnh === RadioRgCnh.rg
  const missingRg = !(rgFrenteFile && rgVersoFile)
  const missingCnh = !cnhFile
  const missingDocument = isRg ? missingRg : missingCnh
  const isSaveButtonDisabled = missingDocument

  function submit() {
    const promises = []
    if (rgFrenteFile) promises.push(rgFrenteFile())
    if (rgVersoFile) promises.push(rgVersoFile())
    if (cnhFile) promises.push(cnhFile())
    setIsLoading(true)
    // FIXME: As promises não esperam o upload terminar para resolver
    Promise.all(promises)
  }

  function onComplete() {
    if (isRg && uploadStatus.current.rgFrente && uploadStatus.current.rgVerso) {
      onChange()
      setIsLoading(false)
    } else if (!isRg && uploadStatus.current.cnh) {
      onChange()
      setIsLoading(false)
    }
  }

  return (
    <>
      <Paragraph>
        Escolha abaixo se deseja enviar o RG (Fentre e verso) ou CNH (Aberta)
      </Paragraph>

      <Padding>
        <RadioRgCnh value={rgCnh} onChange={setRgCnh} />
      </Padding>

      {/* FIXME: Refatorar UploadButtons */}
      <UploadButtons>
        {isRg ? (
          <>
            <Padding>
              <ZoopUploader
                key="rg-frente"
                label="RG Frente"
                onChange={fn => setRgFrenteFile(_ => fn)}
                onComplete={() => {
                  uploadStatus.current.rgFrente = true
                  onComplete()
                }}
              />
            </Padding>
            <Padding>
              <ZoopUploader
                key="rg-verso"
                label="RG Verso"
                onChange={fn => setRgVersoFile(_ => fn)}
                onComplete={() => {
                  uploadStatus.current.rgVerso = true
                  onComplete()
                }}
              />
            </Padding>
          </>
        ) : (
          <>
            <Padding>
              <ZoopUploader
                key="cnh"
                label="CNH (Aberta)"
                onChange={fn => setCnhFile(_ => fn)}
                onComplete={() => {
                  uploadStatus.current.cnh = true
                  onComplete()
                }}
              />
            </Padding>
          </>
        )}
      </UploadButtons>

      {/* FIXME: Criar componente SaveButton */}
      <Space align="end" direction="vertical">
        <Button
          loading={isLoading}
          onClick={submit}
          type="primary"
          disabled={isSaveButtonDisabled}>
          Salvar
        </Button>
      </Space>
    </>
  )
}
